import * as Sentry from '@sentry/react';

export class LogUtils {
  static getUnits(log) {
    if (log && log.units && typeof log.units.toLowerCase !== 'function') {
      const scope = new Sentry.Scope();
      scope.setContext('log', {
        ...log,
      });
      Sentry.captureMessage('getUnits', scope);
    }

    return log?.units?.toLowerCase?.() ?? null;
  }
}
